import { render, staticRenderFns } from "./Homev2.vue?vue&type=template&id=278cc878&scoped=true&"
import script from "./Homev2.vue?vue&type=script&lang=js&"
export * from "./Homev2.vue?vue&type=script&lang=js&"
import style0 from "./Homev2.vue?vue&type=style&index=0&id=278cc878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278cc878",
  null
  
)

export default component.exports